export default __webpack_public_path__ + "static/media/book.a0446e27.png";